import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center my-1" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative w-250px" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "d-flex align-items-center position-relative w-250px ms-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "card-toolbar" }
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-2\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M19 15C20.7 15 22 13.7 22 12C22 10.3 20.7 9 19 9C18.9 9 18.9 9 18.8 9C18.9 8.7 19 8.3 19 8C19 6.3 17.7 5 16 5C15.4 5 14.8 5.2 14.3 5.5C13.4 4 11.8 3 10 3C7.2 3 5 5.2 5 8C5 8.3 5 8.7 5.1 9H5C3.3 9 2 10.3 2 12C2 13.7 3.3 15 5 15H19Z\" fill=\"currentColor\"></path><path d=\"M13 17.4V12C13 11.4 12.6 11 12 11C11.4 11 11 11.4 11 12V17.4H13Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M8 17.4H16L12.7 20.7C12.3 21.1 11.7 21.1 11.3 20.7L8 17.4Z\" fill=\"currentColor\"></path></svg></span>", 1)
const _hoisted_14 = { value: "" }
const _hoisted_15 = { value: "pending" }
const _hoisted_16 = { value: "delivered" }
const _hoisted_17 = { value: "canceled" }
const _hoisted_18 = { value: null }
const _hoisted_19 = { value: true }
const _hoisted_20 = { value: false }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "card-body py-4 position-relative" }
const _hoisted_23 = {
  key: 0,
  class: "position-absolute w-100 h-100 top-0 start-0 bg-white bg-opacity-50 d-flex align-items-center justify-content-center",
  style: {"z-index":"100"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  class: "table-responsive",
  style: {"min-width":"1200px"}
}
const _hoisted_27 = { class: "table align-middle table-row-dashed fs-6 gy-5 w-100" }
const _hoisted_28 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_29 = { class: "w-10px pe-2" }
const _hoisted_30 = { class: "form-check form-check-sm form-check-custom form-check-solid me-3" }
const _hoisted_31 = ["checked"]
const _hoisted_32 = { class: "min-w-100px" }
const _hoisted_33 = { class: "min-w-100px" }
const _hoisted_34 = { class: "min-w-150px" }
const _hoisted_35 = { class: "min-w-200px" }
const _hoisted_36 = { class: "min-w-100px" }
const _hoisted_37 = { class: "min-w-100px" }
const _hoisted_38 = { class: "min-w-100px" }
const _hoisted_39 = { class: "min-w-150px" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "用户备注", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-80px" }, "运费", -1)
const _hoisted_42 = { class: "min-w-100px" }
const _hoisted_43 = { class: "min-w-100px text-end" }
const _hoisted_44 = { class: "text-gray-600 fw-semibold" }
const _hoisted_45 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "mb-2" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "mb-2" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = { class: "mb-2" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = ["placeholder"]
const _hoisted_54 = { value: true }
const _hoisted_55 = { value: false }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = {
  key: 0,
  style: {"white-space":"pre-wrap","word-break":"break-all"}
}
const _hoisted_58 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_59 = {
  key: 0,
  class: "badge badge-light-warning"
}
const _hoisted_60 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_61 = {
  key: 2,
  class: "badge badge-light-info"
}
const _hoisted_62 = { class: "text-end" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "d-flex justify-content-end py-0" }
const _hoisted_71 = { class: "dialog-footer" }
const _hoisted_72 = { class: "mb-4" }
const _hoisted_73 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_74 = { class: "alert alert-info" }
const _hoisted_75 = { class: "d-flex justify-content-between" }
const _hoisted_76 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_77 = { class: "table-responsive" }
const _hoisted_78 = { class: "table table-sm" }
const _hoisted_79 = ["checked"]
const _hoisted_80 = ["value", "disabled", "title"]
const _hoisted_81 = ["onUpdate:modelValue", "max"]
const _hoisted_82 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_83 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 3,
  class: "text-center py-4"
}
const _hoisted_86 = { class: "text-muted" }
const _hoisted_87 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid ps-15",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                placeholder: _ctx.$t('search_product')
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.search]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid ps-15",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userMobile) = $event)),
                placeholder: _ctx.$t('search_user_mobile')
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.userMobile]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary ms-5",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
            }, _toDisplayString(_ctx.$t('search')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light-primary me-5",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)))
            }, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('download_excel')), 1)
            ]),
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.dateRange,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateRange) = $event)),
              type: "daterange",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "YYYY-MM-DD",
              class: "me-5",
              style: {"width":"240px"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status) = $event)),
              class: "form-select form-select-solid w-150px me-5"
            }, [
              _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('all_status')), 1),
              _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('pending')), 1),
              _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('deliver')), 1),
              _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('cancelled')), 1)
            ], 512), [
              [_vModelSelect, _ctx.status]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.purchased) = $event)),
              class: "form-select form-select-solid w-150px me-5"
            }, [
              _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('all_purchased')), 1),
              _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('purchased')), 1),
              _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t('not_purchased')), 1)
            ], 512), [
              [_vModelSelect, _ctx.purchased]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary ms-5",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleBatchDeliver && _ctx.handleBatchDeliver(...args))),
              disabled: _ctx.selectedItems.length === 0
            }, _toDisplayString(_ctx.$t('batch_deliver')), 9, _hoisted_21),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info ms-5",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openBatchOperationDialog && _ctx.openBatchOperationDialog(...args)))
            }, _toDisplayString(_ctx.$t('batch_operation')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("table", _hoisted_27, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_28, [
                _createElementVNode("th", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      checked: _ctx.isAllSelected,
                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                    }, null, 40, _hoisted_31)
                  ])
                ]),
                _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('user_nickname')), 1),
                _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('user_mobile')), 1),
                _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('product_name')), 1),
                _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('shipping_order')), 1),
                _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('shipping_status')), 1),
                _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('purchased')), 1),
                _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('purchase_price')), 1),
                _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('note')), 1),
                _hoisted_40,
                _hoisted_41,
                _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.$t('created_at')), 1),
                _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.$t('actions')), 1)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_45, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: item.id,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedItems) = $event))
                      }, null, 8, _hoisted_46), [
                        [_vModelCheckbox, _ctx.selectedItems]
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.user_nickname), 1),
                  _createElementVNode("td", null, _toDisplayString(item.user_mobile), 1),
                  _createElementVNode("td", null, _toDisplayString(item.product_name), 1),
                  _createElementVNode("td", null, [
                    (_ctx.editingId === item.id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_47, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editForm.name) = $event)),
                              class: "form-control form-control-sm form-control-solid",
                              placeholder: _ctx.$t('recipient_name')
                            }, null, 8, _hoisted_48), [
                              [_vModelText, _ctx.editForm.name]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editForm.mobile) = $event)),
                              class: "form-control form-control-sm form-control-solid",
                              placeholder: _ctx.$t('recipient_mobile')
                            }, null, 8, _hoisted_50), [
                              [_vModelText, _ctx.editForm.mobile]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editForm.area) = $event)),
                              class: "form-control form-control-sm form-control-solid",
                              placeholder: _ctx.$t('area')
                            }, null, 8, _hoisted_52), [
                              [_vModelText, _ctx.editForm.area]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editForm.address_detail) = $event)),
                              class: "form-control form-control-sm form-control-solid",
                              placeholder: _ctx.$t('address_detail')
                            }, null, 8, _hoisted_53), [
                              [_vModelText, _ctx.editForm.address_detail]
                            ])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", null, _toDisplayString(item.name), 1),
                          _createElementVNode("div", null, _toDisplayString(item.mobile), 1),
                          _createElementVNode("div", null, _toDisplayString(item.area) + _toDisplayString(item.address_detail), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getStatusClass(item.status))
                    }, _toDisplayString(_ctx.getStatusText(item.status)), 3)
                  ]),
                  _createElementVNode("td", null, [
                    (_ctx.editingId === item.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editForm.purchased) = $event)),
                          class: "form-select form-select-sm form-select-solid"
                        }, [
                          _createElementVNode("option", _hoisted_54, _toDisplayString(_ctx.$t('purchased')), 1),
                          _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.$t('not_purchased')), 1)
                        ], 512)), [
                          [_vModelSelect, _ctx.editForm.purchased]
                        ])
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(item.purchased ? 'badge badge-light-success' : 'badge badge-light-warning')
                        }, _toDisplayString(item.purchased ? _ctx.$t('purchased') : _ctx.$t('not_purchased')), 3))
                  ]),
                  _createElementVNode("td", null, [
                    (_ctx.editingId === item.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "number",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editForm.purchase_price) = $event)),
                          class: "form-control form-control-sm form-control-solid"
                        }, null, 512)), [
                          [_vModelText, _ctx.editForm.purchase_price]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatPrice(item.purchase_price)), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", null, [
                    (_ctx.editingId === item.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editForm.note) = $event)),
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.$t('input_note')
                        }, null, 8, _hoisted_56)), [
                          [_vModelText, _ctx.editForm.note]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(item.note), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", null, [
                    (item.user_note)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(item.user_note), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_58, "-"))
                  ]),
                  _createElementVNode("td", null, [
                    (item.shipping_fee_type === 'freight_collect')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, "到付"))
                      : (item.shipping_fee_type === 'paid')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, "已付运费"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_61, "包邮"))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.created_at), 1),
                  _createElementVNode("td", _hoisted_62, [
                    (_ctx.editingId === item.id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light-primary me-2",
                            onClick: ($event: any) => (_ctx.handleSave(item))
                          }, _toDisplayString(_ctx.$t('save')), 9, _hoisted_63),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light",
                            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                          }, _toDisplayString(_ctx.$t('cancel')), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-light-primary btn-sm me-2",
                            onClick: ($event: any) => (_ctx.startEdit(item))
                          }, _hoisted_66, 8, _hoisted_64),
                          (item.status === 'pending')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-icon btn-light-danger btn-sm",
                                onClick: ($event: any) => (_ctx.handleCancel(item.id))
                              }, _hoisted_69, 8, _hoisted_67))
                            : _createCommentVNode("", true)
                        ], 64))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_component_vxe_pager, {
            "current-page": _ctx.page.currentPage,
            "onUpdate:current-page": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.page.currentPage) = $event)),
            "page-size": _ctx.page.pageSize,
            "onUpdate:page-size": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.page.pageSize) = $event)),
            total: _ctx.page.totalResult,
            layouts: [
              'PrevJump',
              'PrevPage',
              'Number',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total',
            ],
            onPageChange: _ctx.onPageChange
          }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.deliverDialogVisible,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.deliverDialogVisible) = $event)),
      title: _ctx.$t('batch_deliver'),
      width: "500px",
      onOpen: _ctx.resetDeliverForm
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_71, [
          _createVNode(_component_el_button, { onClick: _ctx.closeDeliverDialog }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitDeliver
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('confirm')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "deliverFormRef",
          model: _ctx.deliverForm,
          rules: _ctx.deliverRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('shipping_provider'),
              prop: "shipping_provider"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.deliverForm.shipping_provider,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.deliverForm.shipping_provider) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('shipping_no'),
              prop: "shipping_no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.deliverForm.shipping_no,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.deliverForm.shipping_no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onOpen"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.batchOperationDialogVisible,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.batchOperationDialogVisible) = $event)),
      title: _ctx.$t('batch_operation'),
      width: "800px",
      onOpen: _ctx.resetBatchOperationForm
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_87, [
          _createVNode(_component_el_button, { onClick: _ctx.closeBatchOperationDialog }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitBatchOperation,
            disabled: !_ctx.batchOperationForm.selected_products.length || !_ctx.batchOperationForm.operation
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('confirm')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_72, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _ctx.batchOperationForm,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('search_by_mobile')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.batchOperationForm.user_mobile,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.batchOperationForm.user_mobile) = $event)),
                    placeholder: _ctx.$t('search_mobile_placeholder'),
                    style: {"width":"200px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.searchUserProducts
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('search_products')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        (_ctx.userPendingDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('user_mobile')) + ": " + _toDisplayString(_ctx.userPendingDetails.user_mobile), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('total_product_types')) + ": " + _toDisplayString(_ctx.userPendingDetails.total_products), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('total_quantity')) + ": " + _toDisplayString(_ctx.userPendingDetails.total_quantity), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.userPendingDetails && _ctx.userPendingDetails.products.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('selected_products')), 1),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("table", _hoisted_78, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.isAllBatchSelected,
                          onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.toggleAllBatch && _ctx.toggleAllBatch(...args)))
                        }, null, 40, _hoisted_79)
                      ]),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('product_name')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('quantity')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('purchase_price')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('purchased')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('recipient_info')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPendingDetails.products, (product) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: product.group_key
                      }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: product.group_key,
                            disabled: _ctx.isGroupDisabled(product),
                            title: _ctx.isGroupDisabled(product) ? _ctx.$t('deliver_same_address_only') : '',
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.batchOperationForm.selected_products) = $event))
                          }, null, 8, _hoisted_80), [
                            [_vModelCheckbox, _ctx.batchOperationForm.selected_products]
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(product.product_name), 1),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((product.operation_quantity) = $event),
                            min: 1,
                            max: product.quantity,
                            class: "form-control form-control-sm",
                            style: {"width":"80px"}
                          }, null, 8, _hoisted_81), [
                            [_vModelText, product.operation_quantity]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((product.operation_purchase_price) = $event),
                            class: "form-control form-control-sm",
                            style: {"width":"100px"},
                            placeholder: _ctx.$t('purchase_price')
                          }, null, 8, _hoisted_82), [
                            [_vModelText, product.operation_purchase_price]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(product.purchased ? 'badge badge-light-success' : 'badge badge-light-warning')
                          }, _toDisplayString(product.purchased ? _ctx.$t('purchased') : _ctx.$t('not_purchased')), 3)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(product.shipping_order_name), 1),
                          _createElementVNode("div", null, _toDisplayString(product.shipping_order_mobile), 1),
                          _createElementVNode("div", null, _toDisplayString(product.shipping_order_address), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.batchOperationForm.selected_products.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('operation_type')), 1),
              _createVNode(_component_el_form, {
                model: _ctx.batchOperationForm,
                rules: _ctx.batchOperationRules,
                ref: "batchOperationFormRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "operation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.batchOperationForm.operation,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.batchOperationForm.operation) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: "cancel" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('cancel_shipping')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "deliver" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('deliver_shipping')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "mark_purchased" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('mark_as_purchased')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.batchOperationForm.operation === 'deliver')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('shipping_provider'),
                          prop: "shipping_provider"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.batchOperationForm.shipping_provider,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.batchOperationForm.shipping_provider) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('shipping_no'),
                          prop: "shipping_no"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.batchOperationForm.shipping_no,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.batchOperationForm.shipping_no) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : (_ctx.userPendingDetails && _ctx.userPendingDetails.products.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.$t('no_pending_products')), 1)
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onOpen"])
  ]))
}